var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilePpt = function SvgFilePpt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9E0A28",
    d: "M15 0H4.125A1.12 1.12 0 0 0 3 1.12v21.755A1.12 1.12 0 0 0 4.12 24h15.755A1.123 1.123 0 0 0 21 22.88V6h-5.25a.75.75 0 0 1-.75-.75z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E0A28",
    d: "M21 5.714V6h-5.25a.75.75 0 0 1-.75-.75V0h.286a1.13 1.13 0 0 1 .797.328l4.589 4.594a1.12 1.12 0 0 1 .328.792M3 14h18v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE8EF",
    d: "M7.981 18.552h.39q.648 0 .648-.564t-.648-.564h-.39zm0 2.448H6.805v-4.524h1.872q.762 0 1.164.396.408.396.408 1.116t-.408 1.116q-.402.396-1.164.396h-.696zM12.048 18.552h.39q.647 0 .647-.564t-.648-.564h-.39zm0 2.448H10.87v-4.524h1.872q.762 0 1.165.396.408.396.408 1.116t-.409 1.116q-.401.396-1.164.396h-.696zM16.654 17.472V21h-1.176v-3.528h-.966v-.996h3.108v.996z"
  }))));
};
export default SvgFilePpt;